export type FileListViewMode = 'list' | 'grid';

const STORAGE_KEY = 'fileListViewMode';

/** Reads the persisted Documents view mode, defaulting to 'list'. */
export const loadFileListViewMode = (): FileListViewMode => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored === 'list' || stored === 'grid' ? stored : 'list';
    } catch {
        return 'list';
    }
};

/** Persists the Documents view mode. */
export const saveFileListViewMode = (mode: FileListViewMode): void => {
    try {
        localStorage.setItem(STORAGE_KEY, mode);
    } catch {
        // ignore storage errors (e.g. private mode)
    }
};
